/**
 * MatrixButton - Reusable button component with Simulacra theme
 * Supports primary (Matrix green), secondary (glass), and danger (red) variants
 *
 * Note: Using theme prop to apply colors since styled() Button has limitations
 */
import { Button } from 'tamagui';

export type MatrixButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost';

interface MatrixButtonProps {
  variant?: MatrixButtonVariant;
  children?: React.ReactNode;
  [key: string]: any;
}

export function MatrixButton({ variant = 'primary', children, ...props }: MatrixButtonProps) {
  // Use theme prop and variant styling
  if (variant === 'primary') {
    return (
      <Button
        theme="green"
        {...props}
      >
        {children}
      </Button>
    );
  }

  if (variant === 'secondary') {
    return (
      <Button
        theme="green"
        variant="outlined"
        {...props}
      >
        {children}
      </Button>
    );
  }

  if (variant === 'danger') {
    return (
      <Button
        backgroundColor="$red10"
        color="$background"
        hoverStyle={{
          backgroundColor: '$red9',
        }}
        {...props}
      >
        {children}
      </Button>
    );
  }

  // ghost
  return (
    <Button
      chromeless
      {...props}
    >
      {children}
    </Button>
  );
}
